import { Box, CircularProgress, Divider } from "@mui/joy";
import { Plus } from "lucide-react";
import { Link } from "react-router-dom";
import { useContractTemplate } from "../../../../hooks/query";
import Breadcrumb from "../Breadcrumb";
import { DataGridSetting } from "../../../../components";
import { Button, Alert } from "../../../../shared";
import { columnDef } from "./column-def";
import { ActionsRenderer } from "./GridFrameworks";

export default function List() {
    const { useList, useDelete } = useContractTemplate();
    const { data: templates, isLoading, isError, error } = useList();
    const deleteTemplate = useDelete();

    const handleDelete = (id: string) => {
        if (window.confirm("Are you sure you want to delete this template?")) {
            deleteTemplate.mutate(id);
        }
    };

    if (isLoading) {
        return (
            <Box flex={1} display="flex" justifyContent="center" alignItems="center">
                <CircularProgress />
            </Box>
        );
    }

    if (isError) {
        return (
            <Box flex={1} p={2}>
                <Box sx={{ color: "danger.plainColor" }}>
                    {error instanceof Error ? error.message : "Failed to load contract templates"}
                </Box>
            </Box>
        );
    }

    const gridData = templates || [];

    return (
        <Box flex={1} display="flex" flexDirection="column">
            <Breadcrumb />
            <Divider />
            <Box flex={1}>
                <DataGridSetting
                    gridData={gridData}
                    columnDefs={columnDef.map((col) => {
                        if (col.cellRenderer === "ActionsRenderer") {
                            return { ...col, cellRenderer: ActionsRenderer };
                        }
                        return col;
                    })}
                    context={{ onDelete: handleDelete }}
                    quickControlStartDecorator={
                        <Box display="flex" alignItems={"center"} ml={1.5}>
                            <Button
                                variant="soft"
                                color="primary"
                                component={Link}
                                to="/admin/contract-template/new"
                                startDecorator={<Plus size={18} />}
                            >
                                Upload Template
                            </Button>
                            <Divider orientation="vertical" sx={{ mt: 1, mb: 1, ml: 2 }} />
                        </Box>
                    }
                />
            </Box>
        </Box>
    );
}
